import { configureStore } from '@reduxjs/toolkit'

import { rootReducers } from 'src/redux/rootReducers'

export default configureStore({
  reducer: rootReducers,
})
